import type React from 'react';
import classes from './work-schedule-page.module.scss';
import { useWorkSchedulePageController } from './useWorkSchedulePageController';
import { ScheduleSidebar } from './components/ScheduleSidebar';
import { ScheduleBoard } from './components/ScheduleBoard';
import { ScheduleDialogs } from './components/ScheduleDialogs';

export const WorkSchedulePage: React.FC = () => {
  const model = useWorkSchedulePageController();
  return (
    <div className={`workspaceLayout ${classes.scheduleWorkspace}`} dir="rtl">
      <ScheduleSidebar {...model} />
      <ScheduleBoard {...model} />
      <ScheduleDialogs {...model} />
    </div>
  );
};
